import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const OrderSummary = ({ orders }) => {
  if (!orders?.length) return null;

  return (
    <div className="card mt-3 shadow-sm">
      <div className="card-body">
        <h5 className="card-title mb-3">Order Summary</h5>
        <div className="table-responsive">
          <table className="table table-bordered table-striped table-hover">
            <thead className="table-light">
              <tr>
                <th>Order ID</th>
                <th>Plan</th>
                <th>Duration</th>
                <th>QR Qty</th>
                <th>Amount</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((order) => (
                <tr key={order._id}>
                  <td>{order._id.slice(0, 8)}...</td>
                  <td>{order?.planId?.name || "-"}</td>
                  <td>{order?.planDuration || "-"}</td>
                  <td>{order?.quantity || 0}</td>
                  <td>₹{order?.totalAmount?.toFixed(2)}</td>
                  <td>{new Date(order.created).toLocaleDateString("en-GB")}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default OrderSummary;
